






















































import {Vue, Component} from 'vue-property-decorator';
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import TextField from "@/components/inputs/TextField.vue";
import EForm from "@/components/datatable/EForm.vue";
import Id from "@/components/inputs/Id.vue";
import {store} from "@/store";

class UyusmazlikTuru {
  uyus_turleri_id!: number;
  uyap_dava_tur_id!: string;
  aciklama!: string;
}

@Component({
  computed: {
    store() {
      return store
    }
  },
  components: {Id, EForm, TextField, DeleteButton},
})
export default class UyusmazlikTurleri extends Vue {
  dialog: boolean = false;
  formAction: string = this.$store.state.arbApiUrl + 'admin/uyusmazlik_turu';
  formData = new UyusmazlikTuru();
  formTitle: string = "";
  loading: boolean = true;
  headers = [
    {text: "ID", value: "uyus_turleri_id"},
    {text: "UYAP Dava Tür ID", value: "uyap_dava_tur_id"},
    {text: "Açıklama", value: "aciklama"},
    {text: "İşlemler", value: "actions", sortable: false}
  ];
  items: UyusmazlikTuru[] = [];
  search = "";

  mounted() {
    this.loadItems();
  }

  async loadItems() {
    try {
      this.loading = true;
      const response = await this.$http.get(this.$store.state.arbApiUrl + 'admin/uyusmazlik_turleri');
      if (response.data && Array.isArray(response.data)) {
        this.items = response.data;
      } else if (response.data && Array.isArray(response.data.data)) {
        this.items = response.data.data;
      } else {
        this.items = [];
      }
    } catch (e) {
      console.error('HATA ---: ', e);
    } finally {
      this.loading = false;
    }
  }

  editItem(item: UyusmazlikTuru) {
    this.formTitle = "Arabuluculuk Bürosu - Düzenle";
    this.formData = {...item};
    this.formAction = this.$store.state.arbApiUrl + 'admin/uyusmazlik_turu/' + item.uyus_turleri_id;
    this.dialog = true;
  }

  addItem() {
    this.formTitle = "Arabuluculuk Bürosu - Yeni Ekle";
    this.formData = new UyusmazlikTuru();
    this.formAction = this.$store.state.arbApiUrl + 'admin/uyusmazlik_turu';
    this.dialog = true;
  }

  onSuccess() {
    this.loadItems();
    this.dialog = false;
  }
}
